import React from "react";
import { FaArrowRight } from "react-icons/fa";
import ProductSelectionStep from "./ProductSelectionStep";

export default function ConfigStep({
  selectedProducts,
  brandName,
  onToggleProduct,
  onContinue,
}) {
  return (
    <>
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
        <ProductSelectionStep
          selectedProducts={selectedProducts}
          onToggleProduct={onToggleProduct}
          onContinue={() => {}}
          hideContinueButton
        />
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4">
        <p className="text-sm text-gray-500">
          {selectedProducts.length === 0
            ? "Devam etmeden önce en az bir ürün seçin ve gerekirse marka adını girin."
            : `${selectedProducts.length} ürün seçildi.${
                brandName ? ` Marka: ${brandName}` : ""
              }`}
        </p>
        <button
          onClick={onContinue}
          disabled={selectedProducts.length === 0}
          className="flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-sm hover:shadow-md hover:from-indigo-700 hover:to-purple-700 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-sm transition-all duration-200"
        >
          <span>Hesaplama Adımına Geç</span>
          <FaArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </>
  );
}
